angular.module('rjmNg.services').factory('clientEventService', [
  "$http"
  "app"
  "$url"
  (
    $http
    app
    $url
  ) ->

    clientEventService = {}

    clientEventService.fetch = () ->
      $http.get($url("/client/#{app.getClientId()}/event"))

    clientEventService.save = (eventType) ->
      $http(
        url: $url("/client/#{app.getClientId()}/event")
        method: "POST"
        data: {type: eventType}
      )

    clientEventService
  ]
)
